import {Injectable, Injector} from "@angular/core";
import {HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {mergeMap, catchError, map} from "rxjs/operators";
import {UsersService} from "../users/users.service";
import {HelperService} from "../helperService";
import {Router} from "@angular/router";


@Injectable()
export class AuthService {

	private OBJ_router: Router;

	/**
	 * Function > constructor
	 * @param {HttpClient} OBJ_http_client
	 * @param {UsersService} OBJ_user_service
	 * @param {HelperService} OBJ_helper_service
	 * @param OBJ_injector
	 */
	constructor
	(
		private OBJ_http_client: HttpClient,
		private OBJ_user_service: UsersService,
		private OBJ_helper_service: HelperService,
		private OBJ_injector: Injector,
	) {
	} // end function constructor


	/**
	 * Function > authenticate
	 * @param {object} OBJ_user
	 * @return {any}
	 */
	public authenticate(OBJ_user) {

		this.OBJ_helper_service.log(
			{class: 'AuthService', function: 'authenticate'},
			"Authenticating user",
			OBJ_user
		);

		// get config
		let OBJ_config = this.OBJ_helper_service.getFromLocalstorage('config');

		// header and body for oauth
		let JSON_body: any =
			{
				grant_type: "password",
				client_id: OBJ_config.auth.client_id,
				username: OBJ_user.username.toLowerCase(),
				password: OBJ_user.password
			};

		// Reset the Authorization header - otherwise the api tries to verify client_id and secret via this values which are cached in the browser
		let OBJ_http_options = {
			"headers": new HttpHeaders({'Content-Type': 'application/json; charset=utf-8', 'Authorization': ''})
		};

		// call sequence of dependent http calls
		// initial call to get access token (map) --> the returned oauth object contains access token that we using to load user data (mergeMap);
		return this.OBJ_http_client.post(OBJ_config.auth.url_oauth, JSON_body, OBJ_http_options).pipe(
			mergeMap((OBJ_response_oauth: Response) => {

				// oauth successful if there is a access token in the response
				let OBJ_data_oauth = JSON.parse(JSON.stringify(OBJ_response_oauth));
				if (OBJ_data_oauth.access_token) {

					let OBJ_date = new Date();
					OBJ_date.setSeconds(OBJ_date.getSeconds() + OBJ_data_oauth.expires_in);
					OBJ_data_oauth.expires = OBJ_date.toString();

					// store access token in local storage to keep user logged in between page refreshes
					this.OBJ_helper_service.setInLocalstorage('access', OBJ_data_oauth);

					// console log
					this.OBJ_helper_service.log(
						{class: 'AuthService', function: 'authenticate'},
						'access: ' + OBJ_data_oauth
					);

					// let STR_auth = OBJ_oauth.token_type + " " + OBJ_oauth.access_token;
					// let OBJ_headers = new HttpHeaders({"Authorization": STR_auth});
					// console.log("OBJ_auth_headers", OBJ_headers, STR_auth);
					return this.auth(OBJ_config.auth.url_auth);

				} // end if

			}),
			catchError((OBJ_exception: HttpErrorResponse) => {
				this.OBJ_helper_service.error(
					{class: 'AuthService', function: 'authenticate'},
					"Error while logging in ",
					OBJ_exception
				);
				return throwError(OBJ_exception || "Backend server error");
			}));

	} // end function authenticate


	/**
	 * Function > auth
	 * @param {string} STR_url
	 * @return Observable<any>
	 */
	auth(STR_url: string): Observable<any> {

		return this.OBJ_http_client.get(STR_url).pipe(
			map((OBJ_response_auth: Response) => {
				this.OBJ_helper_service.setInLocalstorage('current_user', OBJ_response_auth);
				return OBJ_response_auth;
			}));

	} // end function auth


	/**
	 * Function > logout
	 * @return {void}
	 */
	public logout(): void {
		// remove items from storage
		this.OBJ_helper_service.removeFromStorage();
	} // end function logout


	/**
	 * Function > getToken
	 * @param {string} STR_type
	 * @return {string}
	 */
	public getToken(STR_type): string {

		let OBJ_access = this.OBJ_helper_service.getFromLocalstorage('access');
		return OBJ_access != null ? OBJ_access[STR_type] : null;

	} // end function getToken

	/**
	 * Function > refreshToken
	 * @return {void}
	 */
	public refreshToken(): Observable<any> {

		this.OBJ_helper_service.log({class: 'AuthService', function: 'refreshToken'});

		// get config
		let OBJ_config = this.OBJ_helper_service.getFromLocalstorage('config');

		// header and body for oauth
		this.OBJ_http_client = this.OBJ_injector.get(HttpClient);
		let OBJ_http_options = {
			"headers": new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'})
		};
		let STR_refresh_token = this.getToken("refresh_token");
		let JSON_body: any = {
			grant_type: "refresh_token",
			client_id: OBJ_config.auth.client_id,
			refresh_token: STR_refresh_token
		};
		return this.OBJ_http_client.post(OBJ_config.auth.url_oauth, JSON_body, OBJ_http_options)
			.pipe(map((OBJ_data_oauth: any) => {
					let OBJ_date = new Date();
					OBJ_date.setSeconds(OBJ_date.getSeconds() + OBJ_data_oauth.expires_in);
					OBJ_data_oauth.expires = OBJ_date.toString();
					return OBJ_data_oauth;
				}) // end map
				,
				map((OBJ_data_oauth: any) => {
					// Token konnte erfolgreich nachgeladen werden, lege es in localstorage ab
					if (OBJ_data_oauth.access_token !== "") {
						this.OBJ_helper_service.setInLocalstorage('access', OBJ_data_oauth);
						return OBJ_data_oauth;
					} else {
						// losche Zugangsdaten und leite Nutzer auf Loginseite weiter
						localStorage.removeItem("current_user");
						localStorage.removeItem("access");

						this.OBJ_router = this.OBJ_injector.get(Router);
						this.OBJ_router.navigate(["/login"]);
						return throwError(new Error());

					} // end if

				})
			); // end pipe;
	}
} // end class AuthService

